import React from 'react'
import { Footer as StyledFooter } from '../styles/ComponentStyles'


const Footer = () => {
    return (
        <StyledFooter>
            <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', }}>
                <p>© Solmatix {new Date().getFullYear()}</p>
            </div>
        </StyledFooter>
    )
}

export default Footer
